import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_MOST_ACCESSED_MENUS_REQUEST,
  FETCH_MOST_ACCESSED_MENUS_REQUEST_NEW,
  FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB,
  FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE,
  FETCH_MOST_ACCESSED_MENUS_ERROR,
  FETCH_DEVICES_UPDATE_REQUEST,
  FETCH_DEVICES_UPDATE_SUCCESS,
  FETCH_DEVICES_UPDATE_ERROR,
  FETCH_ACTIVE_INACTIVE_USERS_REQUEST,
  FETCH_ACTIVE_INACTIVE_USERS_SUCCESS,
  FETCH_ACTIVE_INACTIVE_USERS_ERROR,
  FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_REQUEST,
  FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_SUCCESS,
  FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_ERROR,
  FETCH_LIST_MOST_ACCESSED_MENUS_WEB_REQUEST,
  FETCH_LIST_MOST_ACCESSED_MENUS_WEB_SUCCESS,
  FETCH_LIST_MOST_ACCESSED_MENUS_WEB_ERROR,
  FETCH_FUNCIONALITIES_DETAILS_SUCCESS,
  FETCH_FUNCIONALITIES_DETAILS_REQUEST,
  FETCH_FUNCIONALITIES_DETAILS_ERROR,
  FETCH_FILTERS_GLOBAL_SUCCESS

} from 'actionTypes'
import {  mostAccessedMenuDetails } from '../containers/analyticsNew/mock/mostAccessed'
import { FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE_V2, FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB_V2 } from '../constants/actionTypes'

/*
 * REQUEST MOST_ACCESSED_MENUS
 */
export const fetchMostAccessedMenus = (auth, params, signalController) => async (dispatch) => {
  dispatch(fetchMostAccessedMenusRequest())
  const onClose = () => {
    // dispatch(hideSpinner())
  }

  const onError = (error) => {
    dispatch(fetchMostAccessedMenusError(error))
    onClose()
  }

  const type = params.inWeb ? FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB
  : FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE

  const onMessage = (response) => {
    dispatch(fetchMostAccessedMenusSuccess(response.data, type))
    
  }

  return new Promise((resolve, reject) => {
    new Api(auth.user.dsToken, dispatch)
      .eventSourceStream(API_URL.ANALYTICS_MENUS, params, null, signalController, onMessage, onClose, onError)
      .then(resolve)
      .catch(reject);
  });
}

export const fetchMostAccessedMenusRequest = () => ({
  type: FETCH_MOST_ACCESSED_MENUS_REQUEST,
})

export const fetchMostAccessedMenusSuccess = (data, type) => ({
  type,
  payload: data,
})

export const fetchMostAccessedMenusError = (error) => ({
  type: FETCH_MOST_ACCESSED_MENUS_ERROR,
  payload: error,
})

/*
 * REQUEST DEVICES_UPDATE
 */
export const fetchDevicesUpdate = (auth, params, signalController) => async (dispatch) => {
  dispatch(fetchDevicesUpdateRequest())

  const onClose = () => {
    // dispatch(hideSpinner())
  }

  const onError = (error) => {
    dispatch(fetchDevicesUpdateError(error))
    onClose()
  }

  const onMessage = (response) => {
    dispatch(fetchDevicesUpdateSuccess(response.data))
  }

  return new Promise((resolve, reject) =>{
    new Api(auth.user.dsToken, dispatch)
    .eventSourceStream(API_URL.ANALYTICS_DEVICES, params, null, signalController, onMessage, onClose , onError)
    .then(resolve)
    .catch(reject)
  })
  
}

export const fetchDevicesUpdateRequest = () => ({
  type: FETCH_DEVICES_UPDATE_REQUEST,
})

export const fetchDevicesUpdateSuccess = (data) => ({
  type: FETCH_DEVICES_UPDATE_SUCCESS,
  payload: data,
})

export const fetchDevicesUpdateError = (error) => ({
  type: FETCH_DEVICES_UPDATE_ERROR,
  payload: error,
})

/*
 * REQUEST ACTIVE_INACTIVE_USERS
 */
export const  fetchActiveInactiveUsers = (auth, params, signalController) => async (dispatch) => {
  dispatch(fetchActiveInactiveUsersRequest())

  const onClose = () => {
    // dispatch(hideSpinner())
  }

  const onError = (error) => {
    dispatch(fetchActiveInactiveUsersError(error))
    onClose()
  }

  const onMessage = (response) => {
    dispatch(fetchActiveInactiveUsersSuccess(response.data))
  }

  return new Promise((resolve, reject) =>{
    new Api(auth.user.dsToken, dispatch)
    .eventSourceStream(API_URL.ANALYTICS_USERS, params, null, signalController, onMessage, onClose, onError)
    .then(resolve)
    .catch(reject)
  })
   
}

export const fetchActiveInactiveUsersRequest = () => ({
  type: FETCH_ACTIVE_INACTIVE_USERS_REQUEST,
})

export const fetchActiveInactiveUsersSuccess = (data) => ({
  type: FETCH_ACTIVE_INACTIVE_USERS_SUCCESS,
  payload: data,
})

export const fetchActiveInactiveUsersError = (error) => ({
  type: FETCH_ACTIVE_INACTIVE_USERS_ERROR,
  payload: error,
})

/*
 * REQUEST LIST_MOST_ACCESSED_MENUS_MOBILE
 */
export const fetchListMostAccessedMenusMobile =
  (auth, params) => (dispatch) => {
    dispatch(fetchListMostAccessedMenusMobileRequest())

    return new Api(auth.user.dsToken, dispatch)
      .post(API_URL.ANALYTICS_LIST_ACCESSES, params)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(fetchListMostAccessedMenusMobileSuccess(response.data))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchListMostAccessedMenusMobileError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchListMostAccessedMenusMobileRequest = () => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_REQUEST,
})

export const fetchListMostAccessedMenusMobileSuccess = (data) => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_SUCCESS,
  payload: data,
})

export const fetchListMostAccessedMenusMobileError = (error) => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_ERROR,
  payload: error,
})

export const fetchFuncionalitiesDetailsSuccess = (data) => ({
  type: FETCH_FUNCIONALITIES_DETAILS_SUCCESS,
  payload: data
})

export const fetchFuncionalitiesDetailsRequest = () => ({
  type: FETCH_FUNCIONALITIES_DETAILS_REQUEST
})

export const fetchFuncionalitiesDetailsError = (error) => ({
  type: FETCH_FUNCIONALITIES_DETAILS_ERROR,
  payload: error
})

/*
 * REQUEST LIST_MOST_ACCESSED_MENUS_WEB
 */
export const fetchListMostAccessedMenusWeb = (auth, params) => (dispatch) => {
  dispatch(fetchListMostAccessedMenusWebRequest())

  return new Api(auth.user.dsToken, dispatch)
    .post(API_URL.ANALYTICS_LIST_ACCESSES, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchListMostAccessedMenusWebSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchListMostAccessedMenusWebError(error))
      dispatch(hideSpinner())
    })
}

export const fetchListMostAccessedMenusRequestV2 = () => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_REQUEST,
})

export const fetchListMostAccessedMenusSuccess = (data, type) => ({
  type,
  payload: data,
})

export const fetchListMostAccessedMenusError = (error) => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_ERROR,
  payload: error,
})

export const fetchListMostAccessedBranchs = (auth, params) => (dispatch) => {
  const type = params.inWeb ? FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB_V2
  : FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE_V2

  dispatch(fetchListMostAccessedMenusRequestV2())
  return new Api(auth.user.dsToken, dispatch)
  .post(API_URL.ANALYTICS_LIST_ACCESSES_V2, params)
  .then(dispatch(showSpinner()))
  .then((response) => {
    dispatch(fetchListMostAccessedMenusSuccess(response.data, type))
    dispatch(hideSpinner())
  })
  .catch((error) => {
    dispatch(fetchListMostAccessedMenusMobileError(error))
    dispatch(hideSpinner())
  })
}

export const reloadData = (auth, filters, devicesUpdateAbortController, activeInActiveAbortController, mostAccessedMobileAbortController, mostAccessedWebAbortController, onCancelCallback) => async (dispatch) =>  {

  const branchParams = {idBranches: filters.branchs}
  const params = {idBranches: filters.branchs}
  const webParams = {...filters, idBranches: filters.branchs, inWeb: true, limit: 5}
  delete webParams.branchs
  const appParams = {...filters, idBranches: filters.branchs,  inMobile: true, limit: 5}
  delete appParams.branchs

  const abort = ()=>{
    onCancelCallback(true)
    mostAccessedWebAbortController.abort()
    mostAccessedMobileAbortController.abort()
    devicesUpdateAbortController.abort()
    activeInActiveAbortController.abort()
  }

  dispatch(showSpinner("", true, abort))

  dispatch(fetchMostAccessedMenusSuccess([], FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB))
  dispatch(fetchMostAccessedMenusSuccess([], FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE))
  dispatch(fetchDevicesUpdateSuccess({}))
  dispatch(fetchActiveInactiveUsersSuccess({}))

  await Promise.all([
    dispatch(fetchMostAccessedMenus(auth, webParams, mostAccessedWebAbortController)),
    dispatch(fetchMostAccessedMenus(auth, appParams, mostAccessedMobileAbortController)),
    dispatch(fetchDevicesUpdate(auth, branchParams, devicesUpdateAbortController)),
    dispatch(fetchActiveInactiveUsers(auth ,params, activeInActiveAbortController))
  ]).finally(()=> {
    dispatch(hideSpinner())
  }
  )

}

export const fetchFuncionalitiesDetails = () => (dispatch) => {
  dispatch(showSpinner())
  dispatch(fetchFuncionalitiesDetailsSuccess(mostAccessedMenuDetails))
  setTimeout(() =>  {
    dispatch(hideSpinner())},
    1000
    )
}

export const fetchFiltersGlobal = (filters) => (dispatch) => {
  dispatch(fetchFiltersGlobalSuccess(filters))
}

export const  fetchFiltersGlobalSuccess = (data) => ({
  type: FETCH_FILTERS_GLOBAL_SUCCESS,
  payload: data
})

export const fetchListMostAccessedMenusRequest = (data) => ({
  type: FETCH_MOST_ACCESSED_MENUS_REQUEST_NEW,
  payload: data
})

export const fetchListMostAccessedMenusWebRequest = () => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_WEB_REQUEST,
})

export const fetchListMostAccessedMenusWebSuccess = (data) => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_WEB_SUCCESS,
  payload: data,
})

export const fetchListMostAccessedMenusWebError = (error) => ({
  type: FETCH_LIST_MOST_ACCESSED_MENUS_WEB_ERROR,
  payload: error,
})



